module.exports = __webpack_public_path__ + "./fonts/filtergray.1abb62f7a3f88a5a70a8a2cfa49de90d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/filtergray.svg
// module id = ./assets/images/filtergray.svg
// module chunks = 0